import { NotificationTypeEnum, ReleaseStatusEnum } from "../../../dataservice/dto"

export enum ExpirationTypeEnum {
    CASO_A = 'CASO_A',
    CASO_B = 'CASO_B',
    CASO_C = 'CASO_C'
}

export interface NotificationStatusUpdateDTO {
    notificationProtocolId?: string
    expirationType?: ExpirationTypeEnum
    certifiedSubsequentNotificationIssue?: boolean
    certifiedNonCompliantNotification?: boolean
    certifiedOtherCauses?: boolean
    certifiedNote?: string
    notEmittedCertifiedId?: string
    documentIntegrationRequestId?: string
    variationCauses?: string[]
    note?: string
    notificationValidation?: boolean
    validationDate?: Date
    motivation?: string
    additionalNote?: string
    officerId?: string
}

export interface NotificationStatusDTO {
    id: string
    createdAt: Date | null
    updatedAt: Date | null
    deletedAt: Date | null
    notificationId: string
    notificationIdentifier: string
    notificationReleaseDate: Date
    notificationStatus: ReleaseStatusEnum
    notificationType: NotificationTypeEnum
    notificationProtocolId: string
    notificationProtocolInfo: string
    expirationType: ExpirationTypeEnum
    certifiedSubsequentNotificationIssued: boolean
    certifiedNonCompliantNotification: boolean
    certifiedOtherCauses: boolean
    certifiedNote: string
    notEmittedCertifiedId: string
    notEmittedCertifiedInfo: string
    documentIntegrationRequestId: string
    documentIntegrationRequestInfo: string
    variationCauses: string[]
    note: string
    notificationValidation: boolean
    validationDate: Date
    motivation: string
    additionalNote: string
    officerId: string
    officerInfo: string
    lastUpdate: Date
    isImported: boolean
    m005IssueRequest: boolean
    m005IsValid: boolean
    inspectionVisitNeeded: boolean
}

export interface GetAllNotificationStatusDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: NotificationStatusDTO[]
}

export interface GetAllNotificationStatusFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    notificationId?: string
}